<template>
<div class="details">
  <el-dialog title="详情" :visible.sync="dialogVisible" :close-on-click-modal="false" modal-append-to-body @closed="onClose" width="1200px">
    <div class="details-main">
      <ThirdPartyCompanyProjectMonthDetails
        ref="thirdPartyCompanyProjectMonthDetailsRef"
        v-if="dialogVisible"
        :from-data="fromData"
        :year-month="year_month"
        @onSubmit="onSubmit"
      />
    </div>
    <template slot="footer">
      <el-button @click="onClose">取 消</el-button>
      <el-button type="primary" @click="submit" v-if="fromData.status === 1">保 存</el-button>
    </template>
  </el-dialog>
</div>
</template>

<script>
import ThirdPartyCompanyProjectMonthDetails from "./ThirdPartyCompanyProjectMonthDetails";
export default {
  name: "ThirdPartyCompanyProjectMonthDetailsDialog",
  components: {ThirdPartyCompanyProjectMonthDetails},
  data() {
    return {
      dialogVisible: false,
      year_month:"",
      fromData: {},
      callback: null
    }
  },
  methods: {
    show(obj,callback) {
      let data=JSON.parse(JSON.stringify(obj.data))
      this.year_month=obj.year_month;
      this.dialogVisible = true;
      this.fromData = JSON.parse(JSON.stringify(data));
      this.callback = callback;
    },
    submit() {
      this.$refs.thirdPartyCompanyProjectMonthDetailsRef.submit();
    },
    onSubmit(){
      console.log('=> onSubmit')
      this.callback && this.callback();
      this.dialogVisible=false;
    },
    onClose() {
      this.dialogVisible = false;
      this.callback=null;
      this.fromData = {};
    },
  },
}
</script>

<style lang="scss" scoped>
.details{
  >>> .el-dialog__body{
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThirdPartyCompanyProjectMonthDetailsDialog.vue